import { IApplicationState } from '../../types/redux';

export function getSpecifications(state: IApplicationState) {
  return state.newbuilding.specifications;
}

export function getDetailedSpecifications(state: IApplicationState) {
  return state.newbuilding.specificationsDetailed;
}
